import React, {FC} from 'react'
import {Spinner} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import {SalesContactsCardProps} from './types'

// Helper function to format numbers with thousand separators
const formatNumber = (num: number): string => num.toLocaleString()

// Helper function to format currency with thousand separators and 2 decimal places
const formatCurrency = (num: number): string =>
  num.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})

const SalesContactsCard: FC<SalesContactsCardProps> = React.memo(
  ({totalSales, totalContacts, newContacts, loading}) => (
    <div className='metric-group-card card h-100'>
      <div className='card-header border-0 pt-5 pb-0'>
        <div className='card-title'>
          <KTSVG
            path='/media/icons/duotune/graphs/gra007.svg'
            className='svg-icon-2 svg-icon-success me-2'
          />
          <h3 className='fw-bold fs-5 mb-0'>Sales & Contacts</h3>
        </div>
      </div>
      <div className='card-body pt-4'>
        {/* Sales Section */}
        <div className='mb-4 pb-4 border-bottom'>
          <div className='d-flex justify-content-between align-items-center'>
            <span className='fs-7 text-gray-600 fw-semibold'>Total Sales</span>
            <span className='fs-4 fw-bold text-success'>
              {loading ? (
                <Spinner size='sm' animation='border' />
              ) : (
                `$${formatCurrency(totalSales)}`
              )}
            </span>
          </div>
        </div>

        {/* Contacts Section */}
        <div>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <span className='fs-7 text-gray-600 fw-semibold'>Total Contacts</span>
            <span className='fs-4 fw-bold text-primary'>
              {loading ? <Spinner size='sm' animation='border' /> : formatNumber(totalContacts)}
            </span>
          </div>
          <div className='d-flex justify-content-between align-items-center'>
            <span className='fs-7 text-gray-600 fw-semibold'>New Contacts</span>
            <span className='fs-5 fw-bold text-info'>
              {loading ? <Spinner size='sm' animation='border' /> : formatNumber(newContacts)}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
)

SalesContactsCard.displayName = 'SalesContactsCard'

export default SalesContactsCard
